import React from "react";
import { trans } from "./../../Lang";
import { NavLink } from "react-router-dom";

export default class LoginSmile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",

      errorUsername: null,
      errorPassword: null,
      showPassword: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  redirectToForgotPasswordPage() {
    this.props.history.push("/forgot-password");
  }

  validateForm = () => {
    let isValid = false;
    const { username, password } = this.state;

    if (!username) {
      isValid = false;
      this.setState({ errorUsername: "Username harus terisi" });
    } else {
      isValid = true;
      this.setState({ errorUsername: null });
    }

    let validatePassword = password.length >= 6;

    if (!validatePassword) {
      isValid = false;
      this.setState({
        errorPassword: "Password harus terdiri dari 6 karakter",
      });
    } else {
      isValid = true;
      this.setState({ errorPassword: null });
    }

    return isValid;
  };

  handleSubmit(e) {
    e.preventDefault();
    const { username, password } = this.state;

    if (!this.validateForm()) {
      return false;
    }

    this.props.onSubmit({
      username,
      password,
    });
  }

  render() {
    const { username, showPassword, errorUsername, errorPassword } = this.state;
    const { username_smile } = this.props;

    return (
      <div className="mt-2">
        {username_smile && (
          <div>
            Masukkan email dan password untuk SMILE Username{" "}
            <b>{username_smile}</b>
          </div>
        )}
        <form
          onSubmit={this.handleSubmit}
          id="form-login-smile"
          className="form-auth bg-white"
        >
          <div class="row">
            <div className="input-field col s12">
              <input
                required
                id="username"
                type="email"
                value={username}
                onChange={(e) => this.setState({ username: e.target.value })}
                className="validate"
              />
              <label htmlFor="username">Email</label>
              {errorUsername ? (
                <span className="red-text text-darken-2">{errorUsername}</span>
              ) : null}
              <div className="font-tiny">
                Masukkan email Anda, misal ade.putra@mail.com
              </div>
            </div>
            <div className="input-field col s12">
              <input
                required
                id="password"
                type={!showPassword ? "password" : "text"}
                onChange={(e) => this.setState({ password: e.target.value })}
                className="validate"
              />
              <i
                className="btn-show-hide-password material-icons"
                onClick={(e) => this.setState({ showPassword: !showPassword })}
              >
                {showPassword ? "visibility_off" : "visibility"}
              </i>
              <label htmlFor="password">Password</label>

              {errorPassword ? (
                <span className="red-text text-darken-2">{errorPassword}</span>
              ) : null}
              <div className="font-tiny">
                Masukkan password untuk akun eLearning Anda
              </div>
              <div className="forgot-password-wrapper">
                <NavLink className="forgot-password-text" to="/forgot-password">
                  Lupa Password?
                </NavLink>
              </div>
            </div>
            <div className="form-auth__button-group mt-s">
              <button className="btn full mb-s">{trans.login}</button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/components/LoginEmail.js